import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { SetZillowIsPct, SetZillowPlaceType, SetZillowVarType, SetZillowYear, SetZillowYrBuilt } from '../../actions';
import withStyles from '../../decorators/withStyles';
import { pngIcon, xlsIcon } from "../../icons";
import { capitalize, xlt } from "../../utils/utils";
import ToggleText from '../ToggleText';
import ZillowPlaceType from '../ZillowPlaceType';
import styles from './ZillowController.css';


class ZillowController extends Component {

  static propTypes = {
    isEmbed: PropTypes.bool.isRequired,
    handleDownloadClick: PropTypes.func.isRequired,
    zillowEndYr: PropTypes.string.isRequired,
    zillowIsPct: PropTypes.bool.isRequired,
    zillowModel: PropTypes.string.isRequired,
    zillowPathway: PropTypes.string.isRequired,
    zillowPlaceType: PropTypes.string.isRequired,
    zillowPlaceTypeOptions: PropTypes.array.isRequired,
    zillowProb: PropTypes.string.isRequired,
    zillowVarType: PropTypes.string.isRequired,
    zillowYear: PropTypes.string.isRequired,
    zillowYrBuilt: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    const { zillowYrBuilt } = this.props;
    this.yrBuiltOptions = {
      'All': 'Built any year',
      'Since2010': 'Built after 2009',
    };
    this.yrBuiltIdx = zillowYrBuilt === 'All' ? 0 : 1;
  }

  handleZillowVarTypeChange = (value) => this.props.dispatch(SetZillowVarType(value));

  handleZillowIsPctChange = (e) => this.props.dispatch(SetZillowIsPct(!this.props.zillowIsPct));

  handleZillowYearChange = (e) => {
    const newYear = this.props.zillowYear === '2050' ? '2100' : '2050';
    this.props.dispatch(SetZillowYear(newYear));
  };

  handleZillowYrBuiltChange = (e) => {
    this.yrBuiltIdx += 1;
    const optionsList = Object.keys(this.yrBuiltOptions);
    const index = this.yrBuiltIdx % optionsList.length;
    const yrBuilt = optionsList[index];
    this.props.dispatch(SetZillowYrBuilt(yrBuilt));
  };

  handlePlaceTypeChange = (value) => {
    this.props.dispatch(SetZillowPlaceType(value));
  };

  isSelected = (varType) => {
    const { zillowVarType } = this.props;
    return zillowVarType.includes(varType);
  };

  render() {
    const { isEmbed, handleDownloadClick, openDownload, zillowEndYr, zillowIsPct, zillowModel,
            zillowPathway, zillowPlaceType, zillowPlaceTypeOptions, zillowProb,
            zillowRanking, zillowVarType, zillowYear, zillowYrBuilt } = this.props;

    const zillowYrBuiltLabel = this.yrBuiltOptions[zillowYrBuilt];

    const zillowVarTypeTabs = (
      <div className="tab-group">
        <h3 className={'zillowTab ' + (this.isSelected('Zestimate') ? 'active' : '')}
            onClick={this.handleZillowVarTypeChange.bind(this, 'Zestimate')}>
          Home Value
        </h3>
        <h3 className={'zillowTab ' + (this.isSelected('Count') ? 'active' : '')}
            onClick={this.handleZillowVarTypeChange.bind(this, 'Count')}>
          Home Count
        </h3>
        {zillowEndYr !== '2005' ? <h3 className={'zillowTab ' + (this.isSelected('Growth') ? 'active' : '')}
            onClick={this.handleZillowVarTypeChange.bind(this, 'Growth')}>
          New Homes
        </h3> : null}
      </div>
    );

    const yrBuiltToggle = () => {
      return (
        <span>
          <ToggleText>
            <span onClick={this.handleZillowYrBuiltChange}>
              {zillowYrBuiltLabel}
            </span>
          </ToggleText>
          <sup>*</sup>
        </span>
      );
    };

    const placeTypeSelector = (
      <ZillowPlaceType
        handleChange={this.handlePlaceTypeChange}
        isEmbed={isEmbed}
        zillowPlaceType={zillowPlaceType}
        zillowPlaceTypeOptions={zillowPlaceTypeOptions}
      />
    );

    const totalToggle = (
      <ToggleText>
        <span onClick={this.handleZillowIsPctChange}>
          {zillowIsPct ? xlt('Percentage of') : xlt('Total')}
        </span>
      </ToggleText>
    );

    const yearToggle = (
      <ToggleText>
        <span onClick={this.handleZillowYearChange}>
          {zillowYear}
        </span>
      </ToggleText>
    );

    const pngDownloadIcon = (
      <svg className="download-icon" version="1.1" viewBox="0 0 585.918 585.918" onClick={handleDownloadClick.bind(null, 'zillow-img')}>
        {pngIcon}
      </svg>
    );

    const xlsDownloadIcon = (
      <svg className="download-icon" version="1.1" viewBox="0 0 585.918 585.918" onClick={handleDownloadClick.bind(null, 'zillow-xls')}>
        {xlsIcon}
      </svg>
    );

    const zillowDownload = (
      <div className="ZillowDownload download-icons">
        {pngDownloadIcon}
        {xlsDownloadIcon}
      </div>
    );

    const tabBar = (
      <div className="zillowTabBar">
        {zillowVarTypeTabs}
        {zillowDownload}
      </div>
    );

    const varLabel = zillowVarType === 'Zestimate' ? 'home value' : 'homes';

    const mainTitle = (
      <div><var>{totalToggle}</var> <span>{varLabel} at risk of yearly coastal flooding by</span> <var>{yearToggle}</var></div>
    );

    const growthTitle = (
      <div><span>Housing growth rates in riskier vs. safer areas for</span> <var>{yearToggle}</var></div>
    );

    const yrBuiltSelector = (
      <div className="yrBuiltSelector"><span className="label">Home vintage: </span>{yrBuiltToggle()}</div>
    );

    return (
      <div className="ZillowController">
        {!isEmbed ? tabBar : ''}
        <h2>
          {zillowVarType === 'Growth' ? growthTitle : mainTitle}
          <div className="map-settings">
            {zillowVarType === 'Growth' || zillowEndYr === '2005' ? null : yrBuiltSelector}
            <div className="placeTypeSelector"><span className="label">Geographical breakdown: </span>{placeTypeSelector}</div>
          </div>
        </h2>
      </div>
    );
  }
}

export default compose(
  withStyles(styles),
  connect(() => {return {};}),
)(ZillowController);
